import React from "react";
import Colors from "./Colors";
import Fonts from "./Fonts";

const Theme = () => (
  <>
    <Colors />
    <Fonts />
  </>
);

export default Theme;
